import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/logo.png";
import "../../style/style.css";
import ChatwootMenuWidget from "../../components/chatwoot/ChatwootMenuWidget";

const SidebarSection = ({ title, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <li className="sidebar-section">
            <button
                type="button"
                className="sidebar-link sidebar-toggle"
                onClick={() => setOpen((o) => !o)}
                aria-expanded={open}
            >
                <span>{title}</span>
                <span className={`sidebar-caret${open ? ' open' : ''}`}>&#8250;</span>
            </button>
            <ul className={`sidebar-submenu${open ? ' open' : ''}`}>{children}</ul>
        </li>
    );
};

const Navbar = () => {
    const { permissions } = useAuth();

    // Empurra o conteúdo da página para a direita da sidebar fixa (só enquanto montada).
    useEffect(() => {
        document.body.classList.add('has-sidebar');
        return () => document.body.classList.remove('has-sidebar');
    }, []);

    const HandleExitSystem = async (event) => {
        event.preventDefault();
        localStorage.removeItem('token');
        window.location.href = `${window.location.origin}/login`;
        window.location.reload();
    };

    // Fecha a sidebar no mobile ao navegar por um link
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleNavClick = (e) => {
        if (e.target.closest('a')) {
            setMobileOpen(false);
        }
    };

    return (
        <>
            <button
                type="button"
                className="sidebar-mobile-toggle"
                onClick={() => setMobileOpen((o) => !o)}
                aria-label="Abrir menu"
            >
                &#9776;
            </button>

            {mobileOpen && <div className="sidebar-backdrop" onClick={() => setMobileOpen(false)} />}

            <nav className={`sidebar-vertical${mobileOpen ? ' mobile-open' : ''}`}>
                <div className="sidebar-header">
                    <Link to="/home" onClick={() => setMobileOpen(false)}>
                        <img src={logo} alt="Transtec World" className="sidebar-logo" />
                    </Link>
                </div>

                <div className="sidebar-nav-scroll" onClick={handleNavClick}>
                    <ul className="sidebar-menu">
                        <li>
                            <Link to="/home" className="sidebar-link">
                                <i className="bi bi-house-door me-2"></i>Home
                            </Link>
                        </li>

                        {(!permissions.gate) && (
                            <SidebarSection title={<><i className="bi bi-person-plus me-2"></i>Cadastros</>}>
                                {(permissions.cliente || permissions.clienteSup || permissions.dev) && (
                                    <li>
                                        <Link className="sidebar-sublink" to="/cadastro_entidade?codCadastro=1"
                                              target="_blank" rel="noopener noreferrer">
                                            Cadastros de Clientes
                                        </Link>
                                    </li>
                                )}
                                {(permissions.cliente || permissions.clienteSup || permissions.dev) && (
                                    <li>
                                        <Link className="sidebar-sublink" to="/cadastro_entidade?codCadastro=2"
                                              target="_blank" rel="noopener noreferrer">
                                            Cadastros de Motoristas
                                        </Link>
                                    </li>
                                )}
                                {(permissions.cliente || permissions.clienteSup || permissions.dev) && (
                                    <li>
                                        <Link className="sidebar-sublink" to="/cadastro_entidade?codCadastro=3"
                                              target="_blank" rel="noopener noreferrer">
                                            Cadastros de Vistoriadores
                                        </Link>
                                    </li>
                                )}
                            </SidebarSection>
                        )}

                        {(!permissions.gate) && (
                            <SidebarSection title={<><i className="bi bi-calendar-check me-2"></i>Solicitações</>}>
                                <li>
                                    <Link className="sidebar-sublink" to="/consulta_devolucao">
                                        Devolução
                                    </Link>
                                </li>
                                <li>
                                    <Link className="sidebar-sublink" to="/consulta_retirada">
                                        Retirada
                                    </Link>
                                </li>
                            </SidebarSection>
                        )}

                        {(permissions.gate || permissions.dev || permissions.admin || permissions.gGeral) && (
                            <SidebarSection title={<><i className="bi bi-calendar-check me-2"></i>Gate</>}>
                                <li>
                                    <Link className="sidebar-sublink" to="/qr_consulta">
                                        Consulta QR Code bookings
                                    </Link>
                                </li>
                            </SidebarSection>
                        )}

                        {(permissions.dev || permissions.admin || permissions.gGeral || permissions.clienteSup) && (
                            <SidebarSection title={<><i className="bi bi-gear me-2"></i>Gerenciar</>}>
                                <li>
                                    <Link className="sidebar-sublink" to="/contatos">
                                        Meus Contatos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="sidebar-sublink" to="/usuarios">
                                        Usuários
                                    </Link>
                                </li>
                            </SidebarSection>
                        )}

                        {(permissions.dev || permissions.admin || permissions.gGeral || permissions.supDoc) && (
                            <SidebarSection title={<><i className="bi bi-tools me-2"></i>Configurações</>}>
                                <li>
                                    <Link className="sidebar-sublink" to="/manutencao">
                                        Manutenção
                                    </Link>
                                </li>
                            </SidebarSection>
                        )}
                    </ul>
                </div>

                <div className="sidebar-footer">
                    <span className="sidebar-user">
                        <i className="bi bi-person-circle me-1"></i>
                        {localStorage.userName}
                    </span>

                    <ChatwootMenuWidget className="sidebar-action-btn" />

                    <button type="button" className="sidebar-action-btn sidebar-exit-btn" onClick={HandleExitSystem}>
                        <i className="bi bi-box-arrow-right"></i> Sair
                    </button>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
